import Input from 'component/atom/forms/input/input/Input';
import Toggle from 'component/atom/forms/toggle/Toggle';
import { useFormikContext } from 'formik';
import React from 'react';
import styles from './fields.module.scss';

const NumberField = ({ index, field }) => {
  const formik = useFormikContext();

  return (
    <div className={`${styles['field']} ${styles['number']}`}>
      <Input
        label="Input Label"
        placeholder="Enter Label"
        name={`formDetails[${index}].fieldLabel`}
        value={field.fieldLabel}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched.formDetails?.[index]?.fieldLabel &&
          formik.errors.formDetails?.[index]?.fieldLabel
        }
        touched={
          formik.touched.formDetails?.[index]?.fieldLabel &&
          formik.errors.formDetails?.[index]?.fieldLabel
        }
      />
      <Input
        label="Input Placeholder"
        placeholder="Enter Placeholder"
        name={`formDetails[${index}].placeHolder`}
        value={field.placeHolder}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={
          formik.touched.formDetails?.[index]?.placeHolder &&
          formik.errors.formDetails?.[index]?.placeHolder
        }
        touched={
          formik.touched.formDetails?.[index]?.placeHolder &&
          formik.errors.formDetails?.[index]?.placeHolder
        }
      />
      <div className={styles['fieldContainer']}>
        <Input
          label="Max Limit"
          placeholder="Enter "
          name={`formDetails[${index}].characterLimit`}
          value={field.characterLimit}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.formDetails?.[index]?.characterLimit &&
            formik.errors.formDetails?.[index]?.characterLimit
          }
          touched={
            formik.touched.formDetails?.[index]?.characterLimit &&
            formik.errors.formDetails?.[index]?.characterLimit
          }
        />
        <Toggle
          label="Required"
          left={true}
          name={`formDetails[${index}].isMandatory`}
          value={field.isMandatory}
          onChange={(e) =>
            formik.setFieldValue(
              `formDetails[${index}].isMandatory`,
              e.target.value
            )
          }
          style={{ flexDirection: 'column' }}
        />{' '}
      </div>
    </div>
  );
};

export default NumberField;
